import useStateWithChange from '@/shared/hooks/useStateWithChange.ts'
import useNestedArrayChangeCallbacks from '@/shared/hooks/useNestedArrayChangeCallbacks.ts'
import { memo, useEffect } from 'react'
import { ITableWidget } from '@/pages/Dashboards/dashboards.types.ts'
import { ITableChartSettings } from '@/pages/Dashboards/Charts/TableChart/tableChart.types.ts'
import tableChartUtils from '@/pages/Dashboards/Charts/TableChart/tableChart.utils.ts'
import TableChartSettingsContent from '@/pages/Dashboards/Charts/TableChart/TableChartSettingsContent'

interface IProps {
  onChange: (val: ITableChartSettings) => void
  widget: ITableWidget
}

const UpdateTableChartWidgetContent = (props: IProps) => {
  const [settings, setSettings, handleChange] = useStateWithChange(props.widget.configuration.settings)

  useEffect(() => {
    props.onChange(settings)
  }, [settings, props.onChange])

  const {
    handleElementDelete: handleLineDelete,
    handleElementUpdate: handleLineUpdate,
    handleCreateNewElement: handleLineCreate,
  } = useNestedArrayChangeCallbacks({
    nestedArrayKey: 'dataRows',
    sourceObjectSetter: setSettings,
    newEntityGenerator: tableChartUtils.generateEmptyLine,
  })

  return (
    <div className="flex-lines gap16">
      <h4 className="text-heading-4">Настройки виджета: Линейный график</h4>
      <TableChartSettingsContent
        settings={settings}
        onChange={handleChange}
        handleDataRowDelete={handleLineDelete}
        handleDataRowUpdate={handleLineUpdate}
        handleDataRowCreate={handleLineCreate}
      />
    </div>
  )
}

export default memo(UpdateTableChartWidgetContent)
